<template>
   <div class="subscribe-container">
      <transition name="fade">
         <div>
            <div v-if="!showForm">
               <button class="subscribe-button" :data-umami-event="`Clicked Subscribe Button`" @click="showForm = true">Subscribe</button>
            </div>

            <div v-else class="form-container">
               <div class="form-row">
                  <input 
                     type="email" 
                     v-model="email" 
                     placeholder="Enter your email"
                     class="email-input"
                     @keyup.enter="submitEmail"
                  />
                  <button class="submit-button" @click="submitEmail" :data-umami-event="`Clicked Submit Email`" :disabled="loading">
                     <span v-if="!loading">Submit</span>
                     <span v-else class="spinner"></span>
                  </button>
               </div>

               <transition name="fade">
                  <div v-if="message" :class="{'success': success, 'error': !success}" class="message">
                     {{ message }}
                  </div>
               </transition>
            </div>
         </div>
      </transition>
   </div>
</template>

<script>
import { saveSubscriber } from '../../backend/index.js';
export default {
   data() {
      return {
         showForm: false,
         email: '',
         message: '',
         success: false,
         loading: false
      }
   },
   methods: {
      submitEmail() {
         if (!this.validateEmail(this.email)) {
            this.message = "Please enter a valid email.";
            this.success = false;
            return;
         }

         this.loading = true;

         saveSubscriber({ email: this.email })
            .then(result => {
               let data = result.data;
               if (data.status === 'success') {
                  this.loading = false;
                  this.message = data.message;
                  this.success = true;
                  this.email = '';
                  setTimeout(() => {
                     this.message = '';
                     this.success = false;
                  }, 3000);
               } else {
                  this.loading = false;
                  this.submitted = false;
                  this.message = data.message;
               }
            })
            .catch(error => {
               this.response = 'Failed to submit request.';
            });
      },
      validateEmail(email) {
         const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
         return re.test(email);
      }
   }
}
</script>

<style scoped>
.subscribe-container {
   display: flex;
   flex-direction: column;
   align-items: center;
}

.subscribe-button {
   padding: 12px 24px;
   border: 2px solid #fdfdfd; /* theme white light color */;
   background-color: transparent;
   color: #fdfdfd; /* theme white light color */;
   font-size: 16px;
   font-weight: 600;
   border-radius: 6px;
   cursor: pointer;
   transition: all 0.3s ease;
   opacity: 0.88;
}

.subscribe-button:hover {
   background-color: #fdfdfd; /* theme white light color */;
   color: black;
}

.form-container {
   display: flex;
   flex-direction: column;
   align-items: center;
}

.form-row {
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}

.email-input {
   padding: 10px 16px;
   font-size: 16px;
   border: 2px solid #fdfdfd; /* theme white light color */;
   border-radius: 6px;
   margin-right: 12px;
   background-color: transparent;
   color: #fdfdfd; /* theme white light color */;
   outline: none;
   transition: border-color 0.3s ease;
   width: 250px;
}

.email-input::placeholder {
   color: rgba(255, 255, 255, 0.7);
}

.email-input:focus {
   border-color: #ccc;
}

.submit-button {
   padding: 10px 24px;
   border: 2px solid #fdfdfd; /* theme white light color */;
   background-color: transparent;
   color: #fdfdfd; /* theme white light color */;
   font-size: 16px;
   font-weight: 600;
   border-radius: 6px;
   cursor: pointer;
   transition: all 0.3s ease;
   position: relative;
}

.submit-button:hover:enabled {
   background-color: #fdfdfd; /* theme white light color */;
   color: black;
}

.submit-button:disabled {
   opacity: 0.6;
   cursor: not-allowed;
}

.spinner {
   width: 16px;
   height: 16px;
   border: 2px solid #fdfdfd; /* theme white light color */;
   border-top: 2px solid transparent;
   border-radius: 50%;
   animation: spin 1s linear infinite;
   display: inline-block;
}

@keyframes spin {
   0% { transform: rotate(0deg); }
   100% { transform: rotate(360deg); }
}

.success {
   color: #00ff99;
   margin-top: 10px;
}

.error {
   color: #ff6666;
   margin-top: 10px;
}

.fade-enter-active, .fade-leave-active {
   transition: opacity 0.4s ease;
}
.fade-enter, .fade-leave-to {
   opacity: 0;
}

.message {
   margin-top: 10px;
   font-weight: 500;
}

@media (max-width: 480px) {
   .form-row {
      flex-direction: column;
   }

   .email-input {
      margin-bottom: 1rem;
   }
}

</style>



// WEBPACK FOOTER //
// src/components/form/SubscribeButton.vue